import axios from 'axios';
import { from } from 'rxjs';

export const markLabelPrinted = (fulfillmentIds, isPrinted) => {
  const post = axios.post('/fulfillment/labelprintedstatus', {
    fulfillmentIds,
    isPrinted,
  });

  const order$ = from(post);
  return order$;
};

export const markPackingSlipPrinted = (fulfillmentPlanIds, isPrinted) => {
  const post = axios.post('fulfillmentplan/packingslipstatus', {
    fulfillmentPlanIds,
    isPrinted,
  });

  const order$ = from(post);
  return order$;
};

export const markPickListPrinted = (fulfillmentPlanIds, isPrinted) => {
  const post = axios.post('fulfillmentplan/pickListstatus', {
    fulfillmentPlanIds,
    isPrinted,
  });

  const order$ = from(post);
  return order$;
};

export const preflightEndOfDayDownload = (endOfDayScanFormIds) => {
  const get = axios.get(`/download/EODForm/${endOfDayScanFormIds}`);

  const response$ = from(get);
  return response$;
};

export const generateOrderSummaryDocument = (fulfillmentPlanIds) => {
  const post = axios.post('/report/generate/orderSummary', {
    fulfillmentPlanIds,
  });

  const response$ = from(post);
  return response$;
};

export const generateFulfillmentPlanSummaryDocument = (batchIds) => {
  const post = axios
    .post('/report/generate/fulfillmentPlanSummary', {
      batchIds,
    })
    .then(({ data }) => data);

  const response$ = from(post);
  return response$;
};

export const generatePackingSlipAsync = (fulfillmentPlanIds, packingSlipTemplateId) => {
  const requestBody = {
    fulfillmentPlanIds,
    packingSlipTemplateId,
  };

  return axios.post('/download/packingslip/async', requestBody).then(({ data }) => data);
};

export const generateBatchPackingSlipAsync = (fulfillmentPlanSetIds, excludeAlreadyPrinted) => {
  const requestBody = {
    fulfillmentPlanSetIds,
    excludeAlreadyPrinted,
  };

  return axios.post('/download/packingslip/fulfillmentPlanSets/async', requestBody).then(({ data }) => data);
};

export const generateBatchPickListAsync = (fulfillmentPlanSetIds) => {
  const requestBody = {
    fulfillmentPlanSetIds,
  };

  return axios.post('/download/picklist/fulfillmentPlanSets/async', requestBody).then(({ data }) => data);
};

export const markFullfillmentPlanSetsPackingSlipPrinted = (fulfillmentPlanSetIds, isPrinted) => {
  const body = {
    fulfillmentPlanSetIds,
    isPrinted,
  };
  return axios.post('/fulfillmentPlanSet/packingSlipPrintedStatus', body).then(({ data }) => data);
};

export const markFulfillmentPlanSetsPickListPrinted = (fulfillmentPlanSetIds, isPrinted) => {
  const body = {
    fulfillmentPlanSetIds,
    isPrinted,
  };
  return axios.post('/fulfillmentPlanSet/pickListPrintedStatus', body).then(({ data }) => data);
};

export const generatePickListAsync = (fulfillmentPlanIds, isUseCustomerDocType = false) => {
  const requestBody = {
    fulfillmentPlanIds,
    isUseCustomerDocType,
  };

  return axios.post('/download/picklist/async', requestBody).then(({ data }) => data);
};

export const generateLabelAsync = (fulfillmentPlanIds) => {
  const requestBody = {
    fulfillmentPlanIds,
  };

  return axios.post('/download/label/async', requestBody).then(({ data }) => data);
};

export const generateLabelForFulfillmentsAsync = (fulfillmentIds) => {
  const requestBody = {
    fulfillmentIds,
  };

  return axios.post('/download/label/fulfillments/async', requestBody).then(({ data }) => data);
};

export const generatePurchaseOrdersAsync = (purchaseOrderId, printType) => {
  const requestBody = {
    purchaseOrderId,
    documentType: printType,
  };
  return axios.post('/purchaseOrders/print/async', requestBody).then(({ data }) => data);
};

export const generateLocationBarcodesAsync = (locations, printType) => {
  const barcodes = locations.map((location) => {
    const nameParts = [location.area, location.unit, location.shelf, location.bin].filter(Boolean);
    const name = nameParts.length > 0 ? nameParts.join('-') : location.inventoryLocationId;
    const barcodeContent = location.barcode || location.inventoryLocationId;

    return {
      name,
      barcodeContent,
    };
  });

  const requestBody = {
    barcodes,
    documentType: printType,
  };
  return axios.post('/download/barcodes/async', requestBody).then(({ data }) => data);
};

/**
 * @param {Array<{ name: string, barcodeContent: string }>} barcodes
 * @returns {Promise}
 */
export const generateUomBarcodesAsync = (barcodes) => {
  return axios.post('/download/barcodes/async', { barcodes, documentType: 'uom-barcode' }).then(({ data }) => data);
};
